<template>
  <div class="docproduct">
    <Header />
    <Banner />
    <EmsSolutionPage />
    <Footer />
  </div>
</template>

<script>
import Banner from '../components/Banner.vue'
import Footer from '../components/Footer.vue'
import Header from '@/components/Header.vue'
import EmsSolutionPage from '@/components/EmsSolutionPage.vue'

export default {
  name: 'docproduct',
  components: {
    EmsSolutionPage,
    Header,
    Banner,
    Footer,
  }
}
</script>

<style lang="scss">

</style>